module.exports = __webpack_public_path__ + "components/flag/static/square/kn-64971f902b1d3a8aa6eb6a592931436a.svg";